export const initialAbonneFormData = {
    prenom: '',
    nom: '',
    residence: '',
    email: '',
    telephone: '',
    genre: '',
    dateNaissance: '',
    typeCarte: '',
    infoSupplementaire: '',
    antecedentsMedicaux: '',
    medicamentsActuels: '',
    medecinTraitant: '',
    numeroSecuriteSociale: '',
    nomPharmacie: '',
    adressePharmacie: '',
    historiqueOrdonnance: '',
    dateDerniereVisite: '',
    username: '',
    password: '',
    questionSecurite: '',
    languePreferee: '',
    notificationPreference: '',
    consentement: '',
  };

export const initialAdminFormData = {
        prenom: '',
        nom: '',
        residence: '',
        email: '',
        telephone: '',
        genre: '',
        dateNaissance: '',
        username: '',
        password: '',
        role: '',
        permissions: '',
};

export const initialServiceFormData = {
  
}

export const initialCarteFormData = {
  abonne: '',
  typeCarte: '',
  structure: '',
  dateExpiration: '',
  institution: '',
  service: '',
};

export const initialCategorFormData = {
  name: ''
};


export const initialPartnerFormData = {
  name: '',
  serviceId: '',
  email: '',
  password: '',
};

export const initialWarrantieFormData = {
  name: '',
  serviceId: '',
  limit: '',
  limitType: '',
  coverage: '',
};